module.exports = __webpack_public_path__ + "static/media/jenkins.b9491e5b.png";